import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

interface Logo {
  id: number;
  nama: string;
  file_url: string;
}

const DataLogo: React.FC = () => {
  const [logos, setLogos] = useState<Logo[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchLogos = async () => {
    try {
      const token = Cookies.get("token");
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/data-logo`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) throw new Error("Gagal ambil data logo");

      const result = await res.json();
      setLogos(Array.isArray(result) ? result : []);
    } catch (err) {
      console.error(err);
      setLogos([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogos();
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading logo...</div>;
  }

  return (
    <>
      <h2 className="text-xl max-sm:text-base  font-semibold text-yellow-900 mt-6 mb-4 border-b-2 border-yellow-400 text-center pb-2">Pilih Bidang Kementrian</h2>

      <div className="my-10 sm:max-w-sm lg:max-w-full mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3  gap-6 justify-center">
          {logos.map((logo) => (
            <div
              key={logo.id}
              onClick={() => navigate(`/detail-bidang/${encodeURIComponent(logo.nama)}`)}
              className="flex items-center gap-6 justify-start cursor-pointer hover:shadow-lg hover:p-2 transition-all duration-300 ease-in-out rounded-xl">
              <img src={logo.file_url} alt={logo.nama} className="w-20 h-20 object-contain" />
              <p className="text-black mt-2 ">{logo.nama}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DataLogo;
